import React, { useEffect, useState } from "react";
import "./style.scss";

function AnimeList(props) {
  const { Heading, InstructionswithRole, SelectPage, setModalIsOpenToTrue } =
    props;
  const [activeslide, setActiveSlide] = useState(0);
  const html = document.getElementsByTagName("html")[0];

  const nextbuttonClick = () => {
    if (activeslide < 4) {
      setActiveSlide(activeslide + 1);
    }
  };
  useEffect(() => {
    
  }, [Heading]);
  useEffect(() => {
    
  }, [InstructionswithRole]);
  useEffect(() => {
    
  }, [SelectPage]);

  return (
    <div class="containerTooltip ">
      <h1>{Heading}</h1>
      <span
        class="closebuttondata"
        onClick={() => {
          setModalIsOpenToTrue();
          html.style.overflow = "auto";
        }}
      ></span>

      <div class="slider-container">
        <div class="slider-turn">
          <ul hidden={!InstructionswithRole[0]}>
            <li
              hidden={!InstructionswithRole[0].Addguidedinstructionssteps[0]}
              className={activeslide == 0 ? "" : "customHidePara"}
            >
              {InstructionswithRole &&
                InstructionswithRole[0].Addguidedinstructionssteps[0]}
            </li>
            <li
              hidden={!InstructionswithRole[0].Addguidedinstructionssteps[1]}
              className={activeslide == 0 ? "" : "customHidePara"}
            >
              {InstructionswithRole &&
                InstructionswithRole[0].Addguidedinstructionssteps[1]}
            </li>
            <li
              hidden={!InstructionswithRole[0].Addguidedinstructionssteps[2]}
              className={activeslide == 0 ? "" : "customHidePara"}
            >
              {InstructionswithRole &&
                InstructionswithRole[0].Addguidedinstructionssteps[2]}
            </li>
            <li
              hidden={!InstructionswithRole[0].Addguidedinstructionssteps[3]}
              className={activeslide == 0 ? "" : "customHidePara"}
            ></li>
          </ul>
          <ul hidden={!InstructionswithRole[1]}>
            <li
              hidden={!InstructionswithRole[1].Addguidedinstructionssteps[0]}
              className={activeslide == 1 ? "" : "customHidePara"}
            >
              {InstructionswithRole &&
                InstructionswithRole[1].Addguidedinstructionssteps[0]}
            </li>
            <li
              hidden={!InstructionswithRole[1].Addguidedinstructionssteps[1]}
              className={activeslide == 1 ? "" : "customHidePara"}
            >
              {InstructionswithRole &&
                InstructionswithRole[1].Addguidedinstructionssteps[1]}
            </li>
            <li
              hidden={!InstructionswithRole[1].Addguidedinstructionssteps[2]}
              className={activeslide == 1 ? "" : "customHidePara"}
            >
              {InstructionswithRole &&
                InstructionswithRole[1].Addguidedinstructionssteps[2]}
            </li>
          </ul>
          <ul hidden={!InstructionswithRole[2]}>
            <li
              hidden={!InstructionswithRole[2].Addguidedinstructionssteps[0]}
              className={activeslide == 2 ? "" : "customHidePara"}
            >
              {InstructionswithRole &&
                InstructionswithRole[2].Addguidedinstructionssteps[0]}
            </li>
            <li
              hidden={!InstructionswithRole[2].Addguidedinstructionssteps[1]}
              className={activeslide == 2 ? "" : "customHidePara"}
            >
              {InstructionswithRole &&
                InstructionswithRole[2].Addguidedinstructionssteps[1]}
            </li>
            <li
              hidden={!InstructionswithRole[2].Addguidedinstructionssteps[2]}
              className={activeslide == 2 ? "" : "customHidePara"}
            >
              {InstructionswithRole &&
                InstructionswithRole[2].Addguidedinstructionssteps[2]}
            </li>
          </ul>
          <ul>
            <li className={activeslide == 3 ? "" : "customHidePara"}>
              It was popularised in the 1960s with the release of Letraset
              sheets containing Lorem Ipsum passages, and more recently with
              desktop
            </li>
            <li className={activeslide == 3 ? "" : "customHidePara"}>
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s
            </li>
            <li className={activeslide == 3 ? "" : "customHidePara"}>
              It was popularised in the 1960s with the release of Letraset
              sheets containing Lorem Ipsum passages, and more recently with
              desktop
            </li>
          </ul>
          <ul>
            <li className={activeslide == 4 ? "" : "customHidePara"}>
              It was popularised in the 1960s with the release of Letraset
              sheets containing Lorem Ipsum passages, and more recently with
              desktop
            </li>
            <li className={activeslide == 4 ? "" : "customHidePara"}>
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s
            </li>
            <li className={activeslide == 4 ? "" : "customHidePara"}>
              It was popularised in the 1960s with the release of Letraset
              sheets containing Lorem Ipsum passages, and more recently with
              desktop
            </li>
          </ul>
        </div>
      </div>
      <div class="bottomlink">
        <div class="stepul">
          <span className="stepsofanmlist">step {activeslide + 1}</span>
          <ul>
            <li
              data-num="0"
              hidden={InstructionswithRole.length <= 0}
              className={activeslide == 0 ? "active" : ""}
            ></li>
            <li
              data-num="1"
              hidden={InstructionswithRole.length <= 1}
              className={activeslide == 1 ? "active" : ""}
            ></li>
            <li
              data-num="2"
              hidden={InstructionswithRole.length <= 2}
              className={activeslide == 2 ? "active" : ""}
            ></li>
            <li
              data-num="3"
              hidden={InstructionswithRole.length <= 3}
              className={activeslide == 3 ? "active" : ""}
            ></li>
            <li
              data-num="4"
              hidden={InstructionswithRole.length <= 4}
              className={activeslide == 4 ? "active" : ""}
            ></li>
          </ul>
        </div>
        <button
          className={
            activeslide < InstructionswithRole.length - 1
              ? "btnNext"
              : "customHideBtn"
          }
          onClick={nextbuttonClick}
        >
          Next
        </button>
        <button
          className={
            activeslide == InstructionswithRole.length - 1
              ? "btnNext"
              : "customHideBtn "
          }
          onClick={setModalIsOpenToTrue}
        >
          Finish
        </button>
      </div>
    </div>
  );
}

export default AnimeList;
